/**
 * Created by JasonChou on 17/1/23.
 */

import { isObject } from './typeUtils';
import getId from 'utils/randomId.js'
import copy from 'fast-copy'

let defaultDefine = {
  style: {
    ieCompatible: null,
    ieHeight: null,
    ieWidth: null,
    widthType: null,
    heightType: null,
    zIndex: null,
    positionType: null,
    flexWeight: null,
    backgroundColor: null,
    boxSizing: 'border-box',
    selectedBackgroundColor: null,
    borderColor: null,
    borderStyle: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomRightRadius: null,
    borderBottomLeftRadius: null,
    boxShadowX: null,
    boxShadowY: null,
    boxShadowType: null,
    boxShadowBlur: null,
    boxShadowWidth: null,
    boxShadowColor: null,
    opacity: 1,
    contentVertical: null,
    contentHorizontal: null,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderRightWidth: null,
    borderLeftWidth: null,
    letterSpacing: 0,
    wordSpacing: 0,
    imgLeftPadding: 0,
    imgRightPadding: 0,
    imgTopPadding: 0,
    imgBottomPadding: 0,
  }
};

//生成一个不重复的id
export const genNonDuplicateID = (index = 0) => {
  return Number(Math.random().toString().substr(3, 6) + Date.now() + index.toString()).toString(36);
};

export const newControlHelper = (controlDefine, style, index = 0, defineMaps = [], props, events, dataSource, controlName = '') => {
  style = Object.assign({}, controlDefine.style, style);
  if (props)
    props = Object.assign({}, props);
  if (events)
    events = Object.assign({}, events);
  if (dataSource)
    dataSource = Object.assign({}, dataSource);

  let control = {
    style,
    type: controlDefine.type,
    typeName: controlDefine.name,
    dataSource: controlDefine.dataSource,
    options: controlDefine.options || [],
    map: controlDefine.map || [],
    name: controlName,
    cate: controlDefine.cate || '',
    componentId: controlDefine.component_id || ''
  };

  if (props)
    control.props = props;
  if (events)
    control.events = events;
  if (dataSource)
    control.dataSource = dataSource;

  control.isOpened = false;
  control.active = true;
  control.id = getId();
  control.controlId = control.id;

  let childControls = [];
  //组合控件
  if (controlDefine.children && controlDefine.children.length) {
    for (let child of controlDefine.children) {
      if (defineMaps[child.type]) {
        index = (index + 1) * 10 + controlDefine.children.indexOf(child) + 1;

        let newDefineMaps = Object.assign({}, defineMaps[child.type]);
        newDefineMaps.children = child.children;
        let childCtrl = newControlHelper(newDefineMaps, child.style, index, defineMaps, child.props);
        childCtrl.active = false;
        childCtrl.parent = control;
        childCtrl.parentId = control.id;
        childControls.push(childCtrl);
      }
    }
  }

  completePropsByDefine(control, null, controlDefine);

  control.children = childControls;
  control.childrenIds = childControls.map(c => c.id)

  if (control.parentId === void 0 || control.parentId === null) {
    control.parentId = ''
  }
  if (control.parent == void 0) {
    control.parent = null
  }
  return control;
};

// 通过template模板创建控件的时候才需要
export const newControlHelperByTemplate = (controlDefine, style, index = 0, defineMaps = [], props, events, dataSource) => {
  style = Object.assign({}, controlDefine.style, style);

  if (props)
    props = Object.assign({}, props);
  if (events)
    events = Object.assign({}, events);
  if (dataSource)
    dataSource = Object.assign({}, dataSource);


  let control = {
    style,
    type: controlDefine.type,
    typeName: controlDefine.name,
    dataSource: controlDefine.dataSource,
    options: controlDefine.options || [],
    map: controlDefine.map || []
  };

  if (props)
    control.props = props;
  if (events)
    control.events = events;
  if (dataSource)
    control.dataSource = dataSource;

  control.isOpened = false;
  control.active = true;
  control.id = getId();

  let childControls = [];
  if (controlDefine.children && controlDefine.children.length) {
    for (let child of controlDefine.children) {
      if (defineMaps[child.type]) {
        index = (index + 1) * 10 + controlDefine.children.indexOf(child) + 1;
        let childCtrl = newControlHelperByTemplate(child, child.style, index, defineMaps);
        childCtrl.active = false;
        childCtrl.parent = control;
        childCtrl.parentId = control.id;
        childControls.push(childCtrl);
      }
    }
  }

  completePropsByDefine(control, null, defineMaps[control.type]);

  control.children = childControls;
  return control;
};

export const updateControl = (controlDefine, style, id, index = 0, defineMaps = [], props, events, extra) => {
  style = Object.assign({}, controlDefine.style, style);
  const extraObj = Object.assign({}, extra);
  if (props)
    props = Object.assign({}, props);
  if (events)
    events = Object.assign({}, events);


  let control = {
    style,
    type: controlDefine.type,
    typeName: controlDefine.name,
    dataSource: controlDefine.dataSource,
  };

  if (props)
    control.props = props;
  if (events)
    control.events = events;

  control.isOpened = false;
  control.active = true;
  control.id = id;

  let childControls = [];
  if (controlDefine.children && controlDefine.children.length) {
    const children = [].concat(extraObj.children);

    for (let child of children) {
      if (defineMaps[child.type]) {
        index = (index + 1) * 10 + controlDefine.children.indexOf(child) + 1;
        let childCtrl = {};
        childCtrl._id = child._id;
        childCtrl = updateControl(
          defineMaps[child.type], child.style, child.id, index, [], {}, {}, child
        );

        childCtrl.active = false;
        childControls.push(childCtrl);
      }
    }
  }

  completePropsByDefine(control, null, controlDefine);
  control.children = childControls;
  control = Object.assign(extraObj, control);

  return control;
};

//根据 defaultDefine 补全controlDefine
export const completeDefineByDefault = (controlDefine) => {
  let style
  if (controlDefine) {
    style = controlDefine.style
  }
  if (controlDefine && typeof controlDefine === 'object')
    controlDefine.style = Object.assign({}, defaultDefine.style || {}, style);
};

//根据controlDefine补全prop
export const completePropsByDefine = (control, controlDefinesMap, controlDefine) => {
  // FIX: controlDefinesMap初始化为空的时候， 没有做处理
  // 理论上 controlDefinesMap不能为空
  let define = controlDefine || controlDefinesMap[control.type] || {};

  let defineProps = define.props;
  if (defineProps) {
    if (!control.props)
      control.props = {};
    for (const prop of Object.keys(defineProps)) {
      if (control.props[prop] === undefined) {
        let default_ = defineProps[prop]['default'];
        if (Array.isArray(default_) || isObject(default_)) {
          default_ = copy(default_);
        }

        control.props[prop] = default_;
      }

    }
  }

  if (define.style && control.type !== 'custom') {
    if (!control.style)
      control.style = {};

    for (const prop of Object.keys(define.style)) {
      if (control.style[prop] === undefined)
        control.style[prop] = define.style[prop];
    }
  }

  if (define.events) {
    if (!control.events)
      control.events = {};

    for (const event of Object.keys(define.events)) {
      if (control.events[event] === undefined)
        control.events[event] = null;
    }
  }

  if (define.dataSource) {
    if (control.dataSource === undefined)
      control.dataSource = define.dataSource.value;
  }

  control.define = define;

  if (control.children) {
    let children = [];
    control.children.map(child => {
      completePropsByDefine(child, controlDefinesMap);
    });
  }

};

export const controlsIsSameParent = (controls) => {
  let parentId = controls[0] && controls[0].parentId || '';
  return controls.every(item => item.parentId === parentId)
};


let filterKeys = {
  'active': 1,
  'parent': 1,
  'typeName': 1,
  'define': 1,
  props: {},
  isOpened: 1
}; //过滤字段

//根据filterKeys删除字段,同事删除为Null的style

function toFilterKeys (filterKeys, target) {
  if (!target)
    return;
  for (const key of Object.keys(filterKeys)) {
    let value = filterKeys[key];
    if (value == 1) {
      delete target[key];
    } else {
      toFilterKeys(value, target[key])
    }
  }
}

export const checkSubmitProps = (parentArr, item) => {
  const defaultBucketName = 'hexyun';
  item = Object.assign({}, item);
  if (item.type !== 'custom') {
    item.style = Object.assign({}, item.style);
  }

  if (item.props)
    item.props = Object.assign({}, item.props);
  if (item.events)
    item.events = Object.assign({}, item.events);

  ['events', 'props', 'dataSource'].map(temp => {
    for (const prop in item[temp]) {
      if (item[temp][prop] == null || item[temp][prop] === '')
        delete item[temp][prop];
    }
  });

  if (item.props) {
    for (const prop of Object.keys(item.props)) {
      //专门处理img类型的prop
      if (item.define.props[prop] && item.define.props[prop].type) {
        if (item.define.props[prop].type === 'img' && item.define.type != 'custom') {
          if (item.props.showType === 1) {
            item.props[prop].map(img => {
              img = {
                _id: img._id,
                type: 'img',
                bucketName: img.bucketName || defaultBucketName,
              }
            });
          } else {
            item.props[prop] = {
              _id: item.props[prop]._id,
              type: 'img',
              bucketName: item.props[prop].bucketName || defaultBucketName,
            }
          }

        } else if (item.define.props[prop].type === 'arrayImg' && item.props[prop]) {
          let values = [];

          try {
            item.props[prop].map(it => {
              values.push({
                _id: it._id,
                bucketName: it.bucketName || defaultBucketName,
              })
            });
          } catch (e) {

          }

          item.props[prop] = {
            type: 'arrayImg',
            pics: values
          };
        }
      }
    }
  }

  if (item.children) {
    let children = [];
    item.children.map(child => {
      checkSubmitProps(children, child);
    });

    item.children = children;
  }

  toFilterKeys(filterKeys, item);
  parentArr.push(item);
};


export const styleTranslate = (rawStyle) => {
  let style = Object.assign({}, rawStyle);

  //需要加单位的
  const unit = {
    'width': 1,
    'height': 1,
    'left': 1,
    'top': 1,
    'right': 1,
    'bottom': 1,
    'line-height': 1,
    'border-radius': 1,
    'font-size': 1,
    'border-width': 1,
    'padding-left': 1,
    'padding-right': 1,
    'padding-top': 1,
    'padding-bottom': 1,
    'margin-left': 1,
    'margin-right': 1,
    'margin-bottom': 1,
    'margin-top': 1,
    'word-spacing': 1,
    'letter-spacing': 1,
    'min-height': 1,
    'text-indent': 1
  };

  //需要加em单位的
  const unitEm = {
    // 'text-indent': 1,
  };


  delete style['visibility']

  const borderRadius = (value, style) => {
    if (style['borderTopLeftRadius'] !== null || style['borderTopRightRadius'] !== null || style['borderBottomRightRadius'] !== null || style['borderBottomLeftRadius'] !== null) {
      style['border-radius'] = (style['borderTopLeftRadius'] || 0) + 'px' + ' ' + (style['borderTopRightRadius'] || 0) + 'px' + ' ' + (style['borderBottomRightRadius'] || 0) + 'px' + ' ' + (style['borderBottomLeftRadius'] || 0) + 'px';
    } else {
      style['border-radius'] = style['borderTopLeftRadius'] + 'px' + ' ' + style['borderTopRightRadius'] + 'px' + ' ' + style['borderBottomRightRadius'] + 'px' + ' ' + style['borderBottomLeftRadius'] + 'px';
    }
  };

  const borderWidth = (value, style) => {
    style['border-width'] = style['borderTopWidth'] + 'px' + ' ' + style['borderRightWidth'] + 'px' + ' ' + style['borderBottomWidth'] + 'px' + ' ' + style['borderLeftWidth'] + 'px';
  };

  const translate = {
    flexMode: (value, style) => {
      if (value) {
        style['display'] = 'flex';
        if (value == 1) {
          style['flex-direction'] = 'row';
        } else if (value == 2) {
          style['flex-direction'] = 'column';
        }
      }
    },

    flexWeight: (value, style) => {
      style['flex'] = value;
    },

    contentVertical: (value, style) => {
      if (value == 1) {
        style['display'] = 'flex';

        if (rawStyle['flexMode'] == 2) {
          style['justify-content'] = 'center';
        } else if (rawStyle['flexMode'] == 1) {
          style['align-items'] = 'center';
        } else {
          style['flex-direction'] = 'column';
          style['justify-content'] = 'center';
        }
      } else if (value == 2) {
        style['display'] = 'flex';

        if (rawStyle['flexMode'] == 2) {
          style['justify-content'] = 'flex-end';
        } else if (rawStyle['flexMode'] == 1) {
          style['align-items'] = 'flex-end';
        } else {
          style['flex-direction'] = 'column';
          style['justify-content'] = 'flex-end';
        }
      }
    },

    contentHorizontal: (value, style) => {
      if (value == 1) {
        style['display'] = 'flex';

        if (rawStyle['flexMode'] == 2) {
          style['align-items'] = 'center';
        } else {
          style['flex-direction'] = 'row';
          style['justify-content'] = 'center';
        }

      } else if (value == 2) {
        style['display'] = 'flex';

        if (rawStyle['flexMode'] == 2) {
          style['align-items'] = 'flex-end';
        } else {
          style['flex-direction'] = 'row';
          style['justify-content'] = 'flex-end';
        }
      }
    },

    widthType: (value, style) => {
      if (style['widthType'] == 1) {
        style['width'] = '100%';
        style['left'] = 0;
      } else if (style['widthType'] == 2) {
        style['width'] = '100%';
        style['left'] = 0;
      } else if (style['widthType'] == 3) {
        delete style['width'];
      }
    },
    heightType: (value, style) => {
      if (style['heightType'] == 3) {
        delete style['height'];
      } else if (style['heightType'] == 1) {
        style['height'] = '100%';
        style['top'] = 0;
      }
    },

    positionType: (value, style) => {
      if (style['positionType'] == 1) {
        style['left'] = 0;
        style['right'] = 0;
        style['top'] = 0;
        delete style['bottom'];
      } else if (style['positionType'] == 2) {
        style['left'] = 0;
        style['right'] = 0;
        style['bottom'] = 0;
        delete style['top'];
      } else if (style.positionType == 3) {
        style['z-index'] = 1000;
        style.left = 0;
        delete style.top;
        delete style.right;
        delete style.bottom;
        style.position = 'fixed';
      } else if (style.positionType == 4) {
        style['z-index'] = 1000;
        style.right = 0;
        delete style.top;
        delete style.bottom;
        delete style.left;
        style.position = 'fixed';
      } else if (style.positionType == 5) {
        style.position = 'fixed';
      } else if (style.positionType == 6) {
        style['right'] = 0;
        style['bottom'] = 0;
        delete style.left;
        delete style['top'];
      } else if (style.positionType == 7) {
        style['left'] = 0;
        style['bottom'] = 0;
        delete style.right;
        delete style['top'];
      }
    },

    textOverflow: (value, style) => {
      if (style['textOverflow'] == 'break-all') {
        style['word-break'] = 'break-all';
        delete style['textOverflow'];
      } else if (style['textOverflow'] == 'ellipsis') {
        style['white-space'] = 'nowrap';
        style['text-overflow'] = 'ellipsis';
        style['overflow'] = 'hidden';
      } else {
        delete style['textOverflow'];
        delete style['white-space'];
      }
    },

    msWritingMode: (value, style) => {
      if (style['msWritingMode'] == '') { } else if (style['msWritingMode'] == 'tb-rl') {
        style['-ms-writing-mode'] = 'tb-rl';
      } else if (style['msWritingMode'] == 'lr-tb') {
        style['-ms-writing-mode'] = 'lr-tb';
      }
    },

    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,

    borderTopWidth: borderWidth,
    borderBottomWidth: borderWidth,
    borderRightWidth: borderWidth,
    borderLeftWidth: borderWidth,
  };


  for (const key of Object.keys(style)) {
    if (translate[key]) {
      translate[key](style[key], style);
      continue;
    }

    let newkey = key.replace(/([A-Z])/g, "-$1").toLowerCase();
    if (newkey != key) {
      style[newkey] = style[key];
      delete style[key];
    }

    if (unit[newkey]) {
      if (!style[newkey])
        delete style[newkey];
      else {
        if (typeof style[newkey] === 'string' && style[newkey].match(/.%/))
          continue;
        style[newkey] += 'px'
      }
    }

    if (unitEm[newkey]) {
      if (!style[newkey])
        delete style[newkey];
      else {
        if (typeof style[newkey] === 'string' && style[newkey].match(/.%/))
          continue;
        style[newkey] += 'em'
      }
    }
  }
  return style;
};

function isExists (id, controls) {
  for (const control of controls) {
    if (control.id === id) {
      return control;
    } else if (control.children) {
      let item = isExists(id, control.children);
      if (item) {
        return item;
      }
    }
  }
}

export const controlsIsExists = (id, controls) => {
  return isExists(id, controls);
};



// WEBPACK FOOTER //
// ./src/utils/controlUtils.js